let $win, $doc, $body, $html, body, RETINA = window.devicePixelRatio > 1;
jQuery(document).ready(function()
{
	$win = jQuery(window);
	$doc = jQuery(document);

	body = document.querySelector('body');

	//settings
	jQuery.datetimepicker.setLocale('nl');
	lmnModal.applySettings({ has_images: false });


	//initialisation
    scUi.init();
	//scUser.init(); now via lmnDynamicPageContents
	scMobileMenu.init();
	scStatementsSlider.init();
	scSearch.init();
	scCommentForm.init();
	scSidebar.init();
	scSidebarStatementFilters.init();
	scSidebarOwnerFilters.init();
	scSidebarAddOwner.init();
	scOrganisationByPerson.init();
	scLoginInfoForm.init();
	scLikeCheck.init();
	scStatementVote.init();

	lmnDynamicPageContents.init();
});
